import AdminReactions from './AdminReactions';

export default AdminReactions;
